import { render, staticRenderFns } from "./DevPageKD5.vue?vue&type=template&id=09b0216e&scoped=true"
import script from "./DevPageKD5.vue?vue&type=script&lang=js"
export * from "./DevPageKD5.vue?vue&type=script&lang=js"
import style0 from "./DevPageKD5.vue?vue&type=style&index=0&id=09b0216e&prod&lang=css"
import style1 from "./DevPageKD5.vue?vue&type=style&index=1&id=09b0216e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b0216e",
  null
  
)

export default component.exports